export const getLanguagesDictionary = <
    K extends string,
    D extends K
>(
    keys: readonly K[] | null,
    defaultLang: D,
  ): Record<Exclude<K, D>, string> => {
  if (keys == null) {
    throw new Error("getLanguagesDictionary: 'keys' must not be null");
  }

  return Object.fromEntries(
    keys
      .filter((k) => k !== defaultLang)
      .map((k) => [k, ''] as const),
  ) as Record<Exclude<K, D>, string>;
};

export const getLanguageName = (code: string): string => {
  switch (code) {
    // Języki zachodnioeuropejskie
    case 'en':
      return 'Angielski';
    case 'de':
      return 'Niemiecki';
    case 'fr':
      return 'Francuski';
    case 'es':
      return 'Hiszpański';
    case 'it':
      return 'Włoski';
    case 'pt':
      return 'Portugalski';
    case 'nl':
      return 'Niderlandzki';
    case 'nl-BE':
      return 'Flamandzki';
    case 'lb':
      return 'Luksemburski';

    // Języki nordyckie
    case 'sv':
    case 'se':
      return 'Szwedzki';
    case 'da':
      return 'Duński';
    case 'no':
    case 'nb':
      return 'Norweski (Bokmål)';
    case 'nn':
      return 'Norweski (Nynorsk)';
    case 'is':
      return 'Islandzki';
    case 'fo':
      return 'Farerski';
    case 'fi':
      return 'Fiński';

    // Języki środkowoeuropejskie
    case 'pl':
      return 'Polski';
    case 'cs':
    case 'cz':
      return 'Czeski';
    case 'sk':
      return 'Słowacki';
    case 'hu':
      return 'Węgierski';
    case 'de-AT':
      return 'Niemiecki (austriacki)';
    case 'de-CH':
      return 'Niemiecki (szwajcarski)';

    // Języki wschodnioeuropejskie i bałtyckie
    case 'ru':
      return 'Rosyjski';
    case 'uk':
    case 'ua':
      return 'Ukraiński';
    case 'be':
      return 'Białoruski';
    case 'lt':
      return 'Litewski';
    case 'lv':
      return 'Łotewski';
    case 'et':
      return 'Estoński';

    // Języki bałkańskie
    case 'hr':
      return 'Chorwacki';
    case 'sr':
      return 'Serbski';
    case 'bs':
      return 'Bośniacki';
    case 'sl':
      return 'Słoweński';
    case 'mk':
      return 'Macedoński';
    case 'bg':
      return 'Bułgarski';
    case 'sq':
      return 'Albański';
    case 'el':
    case 'gr':
      return 'Grecki';
    case 'ro':
      return 'Rumuński';
    case 'mo':
      return 'Mołdawski';
    case 'me':
      return 'Czarnogórski';

    // Języki regionalne półwyspu iberyjskiego
    case 'ca':
      return 'Kataloński';
    case 'gl':
      return 'Galicyjski';
    case 'eu':
      return 'Baskijski';
    case 'oc':
      return 'Oksytański';
    case 'an':
      return 'Aragoński';
    case 'ast':
      return 'Asturyjski';

    // Języki celtyckie
    case 'ga':
      return 'Irlandzki';
    case 'cy':
      return 'Walijski';
    case 'gd':
      return 'Szkocki gaelicki';
    case 'br':
      return 'Bretoński';
    case 'kw':
      return 'Kornijski';
    case 'gv':
      return 'Manx';

    // Języki kaukaskie i tureckie
    case 'tr':
      return 'Turecki';
    case 'ka':
      return 'Gruziński';
    case 'hy':
      return 'Ormiański';
    case 'az':
      return 'Azerbejdżański';

    // Języki regionalne Polski
    case 'szl':
      return 'Śląski';
    case 'csb':
      return 'Kaszubski';

    // Inne języki europejskie
    case 'mt':
      return 'Maltański';
    case 'tt':
      return 'Tatarski';
    case 'rm':
      return 'Retoromański';
    case 'fur':
      return 'Friulski';
    case 'sc':
      return 'Sardyński';
    case 'co':
      return 'Korsykański';

    default:
      return code.toUpperCase();
  }
};
